import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const ConfirmDelete = ({header='Confirm to delete', body='Do you want delete this item ?', isOpen, onCancel, onConfirm}) => {
    return ( 
        <div>
        <Modal isOpen={isOpen} toggle={onCancel} >
          <ModalHeader>{header}</ModalHeader>
          <ModalBody>
             {body}
          </ModalBody>
          <ModalFooter>
            <Button color="danger mr-2" onClick={onConfirm}>Confirm</Button>
            <Button color="secondary" onClick={onCancel}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
     );
}
 
export default ConfirmDelete;